import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="page-loading">Loading your workspace…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
